import React from "react";
import { useTranslation } from "react-i18next";
import { BookOpenIcon } from "@heroicons/react/24/outline";
import JournalSection from "../../../components/dashboard/journaling/JournalSection";

export const JournalsList = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="mb-8 rounded-[2rem] border border-slate-200 bg-white px-6 py-6 shadow-sm">
          <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-slate-600">
            <BookOpenIcon className="h-4 w-4" />
            {t("journal.journals")}
          </div>
          <h1 className="text-3xl font-semibold tracking-tight text-slate-950">
            {t("journal.page_title")}
          </h1>
          <p className="mt-2 max-w-2xl text-sm text-slate-600">
            {t("journal.hero_subtitle")}
          </p>
        </div>

        <JournalSection
          title={t("journal.all_journals")}
          subtitle={t("journal.all_journals_subtitle")}
        />
      </div>
    </div>
  );
};

export default JournalsList;
